import { caseInsensitiveStringEqual } from "./caseInsensitiveStringEqual";

export function isWordPresent(word: string, words: string[]) {
  return words.some((w) => caseInsensitiveStringEqual(w, word));
}
